import React from "react";
import { Routes, Route } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import "./styles/normalize.css";
import "./styles/webflow.css";
import "./styles/index.css";

import Home from "./pages/home";
import ParadigmaPro from "./pages/paradigma-pro";
import SobreNos from "./pages/sobre-nos";
import Ranking from "./pages/ranking";
import LandingVideoTracks from "./pages/landing-video-tracks";
import PreSales from "./pages/pre-sales";
import NotFound from "./pages/not-found";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
});

function App() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/pro" element={<ParadigmaPro />} />
        <Route exact path="/paradigma-pro" element={<ParadigmaPro />} />
        <Route exact path="/sobre-nos" element={<SobreNos />} />
        <Route exact path="/ranking" element={<Ranking />} />
        <Route
          exact
          path="/trilhas/:idTrilhas"
          element={<LandingVideoTracks />}
        />
        <Route exact path="/pre-sales/:idTrilhas" element={<PreSales />} />
        <Route exact path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
